export const GET_LANGUAGE_MANAGE                = 'GET_LANGUAGE_MANAGE';
export const DEL_LANGUAGE_MANAGE                = 'DEL_LANGUAGE_MANAGE';
export const SAVE_LANGUAGE_MANAGE               = 'SAVE_LANGUAGE_MANAGE';
export const RESET_FORM_LANGUAGE_MANAGE         = 'RESET_FORM_LANGUAGE_MANAGE';


